export function registerPwa(): void {
  if (!("serviceWorker" in navigator)) return;
  if (!import.meta.env.PROD) return;

  window.addEventListener("load", () => {
    const ver = import.meta.env.VITE_BUILD_ID ?? String(Date.now());
    void navigator.serviceWorker
      .register(`/sw.js?v=${encodeURIComponent(ver)}`, { scope: "/" })
      .catch(() => {
        // offline shell is best-effort
      });
  });
}
